"use client";

import { FC, useState } from "react";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import FlagRoundedIcon from "@mui/icons-material/FlagRounded";

import { useStyles } from "./styles";
import { useAppSelector, useAppDispatch } from "@/redux/store";
import { sendReport } from "@/redux/actions";
import Modal from "@/components/common/Modal";
import TextField from "@/components/common/TextField";
import PrimaryButton from "@/components/common/PrimaryButton";

interface ReportButtonProps {
  url: string;
  generationUrls: string[];
  className?: string;
}

const ReportButton: FC<ReportButtonProps> = ({
  url,
  generationUrls,
  className,
}) => {
  const { classes } = useStyles();
  const dispatch = useAppDispatch();
  const isAuthenticated = useAppSelector((state) => state.user.isAuthenticated);

  const [text, setText] = useState("");
  const [openModal, setOpenModal] = useState(false);

  const handleOpenReportGeneration = () => {
    setOpenModal(true);
  };
  const handleCloseReportGeneration = () => {
    setOpenModal(false);
  };

  const handleReportGeneration = () => {
    setOpenModal(false);
    if (process.env.NODE_ENV !== "production") return;
    dispatch(sendReport({ url, generationUrls, text }));
  };

  if (!isAuthenticated) return null;

  return (
    <>
      <div className={classes.iconContainer}>
        <Tooltip title="Report inappropriate gen" arrow>
          <IconButton
            className={className}
            onClick={handleOpenReportGeneration}
            aria-label="report idea"
            color="primary"
          >
            <FlagRoundedIcon />
          </IconButton>
        </Tooltip>
      </div>
      <Modal
        heading="Report image"
        open={openModal}
        onClose={handleCloseReportGeneration}
        className={classes.modal}
      >
        <div className={classes.modalContainer}>
          <TextField
            multiline
            className={classes.textField}
            value={text}
            onUpdate={setText}
            placeholder="Reason (optional)"
          />
          <PrimaryButton
            color="secondary"
            className={classes.submitButton}
            onClick={handleReportGeneration}
          >
            Submit
          </PrimaryButton>
        </div>
      </Modal>
    </>
  );
};

export default ReportButton;
